<dap-lib-dropdown
  *ngIf="dates$ | async as dates"
  [formControl]="saleOfferBegin"
  [error]="validatorService.getLoadingErrorMessage(saleOfferBegin, validateForm)"
  [loading]="dates.length === 0"
  [options]="dates"
  label="{{ 'SUMMARY.SALE_OFFER_BEGIN' | translate }}"
  inputId="saleOfferBegin"
  data-cy="input-sale-offer-begin"
  loaderType="skeleton"
>
</dap-lib-dropdown>
